import { useMutation, UseMutationOptions, useQuery, UseQueryResult } from 'react-query';
import { AxiosResponse } from 'axios';
import {
  createAgreementNotifications,
  getAgreementNotifications,
  deleteAgreementNotifications,
  testAgreementNotification,
  ITestNotificationResponse,
} from './api.ts';
import {
  INotification
} from './types.ts';
import { PaginatedResponse, RequestParameters } from '../types';

export enum NotificationHooks {
  Notifications = 'notifications',
}

export function useGetAgreementNotifications(params: RequestParameters = {}): UseQueryResult<PaginatedResponse<INotification>> {
  return useQuery([NotificationHooks.Notifications, params], () => getAgreementNotifications(params));
}

export function useDeleteAgreementNotification(options: UseMutationOptions<unknown, unknown, number>) {
  return useMutation((id: number) => deleteAgreementNotifications(id), options);
}


export function useTestAgreementNotification(
  options: UseMutationOptions<AxiosResponse<ITestNotificationResponse>, unknown, { data: INotification; testEmail?: string }>
) {
  return useMutation(({ data, testEmail }) => testAgreementNotification(data, testEmail), options);
}

export function useCreateAgreementNotifications(
  options: UseMutationOptions<unknown, unknown, INotification>
) {
  return useMutation((data: INotification) => createAgreementNotifications(data), options);
}
